import type { MailFolder } from "owa-graph-schema";
import getStore from "../store/store";
import getFolderTable from "../selectors/getFolderTable";

export const addFoldersToFolderTable = (folders: {
    [id: string]: MailFolder;
}): void => {
    const folderTable = getFolderTable();
    if (folderTable.size == 0) {
        getStore().folderTable = new Map();
    }
    
    const ids = Object.keys(folders);
    for (const id of ids) {
        const newFolderString = JSON.stringify(folders[id]);
        if (JSON.stringify(getFolderTable().get(id)) != newFolderString) {
            const newFolder = JSON.parse(newFolderString);
            getFolderTable().set(id, newFolder);
        }
    }
};
